'use client';
import React from 'react';
import styled from 'styled-components';

import Button from '@/components/Button/Button';
import { Container } from '@/components/Container';
import Section from '@/components/Section/Section';
import { useNewsletterModalContext } from '@/context/newsletter-modal.context';
import { ListItems } from '@/features/ListItems/ListItems';
import { features } from '@/lib/features/features';

const Features = () => {
  const { setIsModalOpened } = useNewsletterModalContext();

  return (
    <>
      <Container>
        <Section title={features.title} description={features.description}>
          <ListItems {...features} />

          <ButtonWrapper>
            <Button
              onClick={() => setIsModalOpened(true)}
              className="secondary"
            >
              Get a Demo
            </Button>
          </ButtonWrapper>
        </Section>
      </Container>
    </>
  );
};

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export default Features;
